import '../../src/css/main.css';
import '../../src/css/custom.css';

import { ready } from './utils/ready';
import initCarousel from "./components/carousel";
import initFilter from "./components/filter";
import initSlider from "./components/slider";
import initVideo from "./components/video";
import initMenu from "./components/mmenu";
import initQuantityHandler from "./utils/quantity-handler";
import toggleSearch from "./utils/toggleSearch";

ready(() => {
    const $ = window.jQuery;

    initMenu()
    initCarousel()
    initSlider()
    initFilter($)
    initVideo()
    initQuantityHandler()
    toggleSearch()
})